/*eslint-disable*/
import React from 'react'
import { OutboundLink } from 'gatsby-plugin-google-analytics'

// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles'
import List from '@material-ui/core/List'
import Grid from '@material-ui/core/Grid'
import ListItem from '@material-ui/core/ListItem'
import Button from '@material-ui/core/Button'
import Divider from '@material-ui/core/Divider'
import Hidden from '@material-ui/core/Hidden'

// core components
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const style = theme => ({
  list: {
    margin: 0,
    paddingLeft: '0',
    listStyle: 'none',
    paddingTop: '0',
    paddingBottom: '0',
  },
  listItem: {
    float: 'left',
    position: 'relative',
    display: 'block',
    width: 'auto',
    margin: '0',
    padding: '0',
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
  },
  iconNavLinks: {
    color: 'inherit',
    padding: '0.9375rem',
    borderRadius: '3px',
    margin: '0px',
    fontSize: '1.25rem',
    display: 'inline-flex',
    '&:hover,&:focus': {
      color: 'inherit',
      background: 'rgba(200, 200, 200, 0.2)',
    },
  },
  navLink: {
    color: 'inherit',
    position: 'relative',
    padding: '0.9375rem',
    textTransform: 'uppercase',
    borderRadius: '3px',
    textDecoration: 'none',
    margin: '0px',
    display: 'inline-flex',
    '&:hover,&:focus': {
      color: 'inherit',
      background: 'rgba(200, 200, 200, 0.2)',
    },
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
  },
})

const MenuLinks = ({ classes, sections }) => {
  return (
    <List className={classes.list}>
      {sections.map(section => (
        <ListItem key={section.name} className={classes.listItem}>
          <Button href={`#${section.name}`} className={classes.navLink}>
            {section.menuTitle}
          </Button>
          <Hidden lgUp implementation="css">
            <Divider />
          </Hidden>
        </ListItem>
      ))}
      <ListItem className={classes.listItem}>
        <Grid container justify="space-evenly">
          <OutboundLink
            href="https://github.com/adrienpoly"
            target="_blank"
            rel="noreferrer"
            className={classes.iconNavLinks}
          >
            <FontAwesomeIcon icon={['fab', 'github']} fixedWidth />
          </OutboundLink>
          <OutboundLink
            href="https://dev.to/adrienpoly"
            target="_blank"
            rel="noreferrer"
            className={classes.iconNavLinks}
          >
            <FontAwesomeIcon icon={['fab', 'dev']} fixedWidth />
          </OutboundLink>
          <OutboundLink
            href="https://twitter.com/adrienpoly"
            target="_blank"
            rel="noreferrer"
            className={classes.iconNavLinks}
          >
            <FontAwesomeIcon icon={['fab', 'twitter']} fixedWidth />
          </OutboundLink>
          <OutboundLink
            href="mailto:adrienpoly@gmail.com"
            target="_blank"
            rel="noreferrer"
            className={classes.iconNavLinks}
          >
            <FontAwesomeIcon icon="envelope" fixedWidth />
          </OutboundLink>
        </Grid>
      </ListItem>
    </List>
  )
}

export default withStyles(style)(MenuLinks)
